<template>
    <div id="caseManage">
        <!-- 病例统计 -->
        <div style="margin-top:10px;">
            <div style="margin:10px auto;border:1px solid #ccc;padding:15px 10px 0px;border-radius:4px;background:#fff;box-sizing:border-box;" align="left">
                <el-form :inline="true" :model="searchForm" style="padding:0 20px;display:flex;justify-content:flex-start;flex-wrap:wrap">
                    <el-form-item label="姓名：">
                        <el-input v-model="searchForm.patientName" placeholder="请输入" style="width:220px"></el-input>
                    </el-form-item>
                    <el-form-item label="性别：">
                        <el-select v-model="searchForm.patientGender" placeholder="请选择" style="width:220px">
                            <el-option v-for="item in sex" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请时间：">
                        <el-date-picker v-model="applyTime" style="width:400px" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="applyTimeChange">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="转诊目的：">
                        <el-select v-model="searchForm.transferPurpose" filterable placeholder="请选择转诊目的">
                            <el-option v-for="item in purposeList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <br>
                    <el-form-item label="地区：">
                        <city-select @hospAddArr='addArr=>{hospAddArr=addArr}' style="width:220px;" :hospCityArr='hospAddArr'/>
                    </el-form-item>
                    <el-form-item label="医院名称：">
                        <el-select v-model="searchForm.hospId" filterable placeholder="请选择转入医院">
                            <el-option v-for="item in hospList" :key="item.hospId" :label="item.hospName" :value="item.hospId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="病例状态：">
                        <el-select v-model="searchForm.caseStatus" filterable placeholder="请选择病例状态">
                            <el-option v-for="item in statusList" :key="item.code" :label="item.value" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="success" @click="search()" circle></el-button>
                        <el-button icon="el-icon-delete" type="danger" @click="clear()" circle></el-button>
                        <el-button icon="el-icon-download" type="warning" @click="exportExcel()" circle></el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div style="width:100%;text-align:right;">
                <el-button type="primary" @click="refresh()" size="small" style="margin-right:20px;"><i class="el-icon-refresh el-icon--left"></i>刷新</el-button>
            </div>
            <div style="margin-top:10px;">
                <template class="table">
                    <el-table :data="tableData.body"  style="width: 100%">
                        <el-table-column header-align=center align="center" type=index label="序号" width="50"></el-table-column>
                            <el-table-column header-align=center align="center" prop="patientName" label="姓名"></el-table-column>
                            <el-table-column header-align=center align="center" prop="patientGender" label="性别" :formatter="sixForamt"></el-table-column>
                            <el-table-column header-align=center align="center" prop="patientAge" label="年龄"></el-table-column>
                            <el-table-column header-align=center align="center" prop="applyHospName" label="转出医院" width='170'></el-table-column>
                            <el-table-column header-align=center align="center" prop="receiveHospName" label="转入医院" width='170'></el-table-column>
                            <el-table-column header-align=center align="center" prop="applyTime" label="申请时间" width='170'></el-table-column>
                            <el-table-column header-align=center align="center" prop="receiveTime" label="到诊时间" width='170'></el-table-column>
                            <el-table-column header-align=center align="center" prop="expenseType" label="报销类型" :formatter="transformExpense"></el-table-column>
                            <el-table-column header-align=center align="center" prop="transferPurpose" label="转诊目的" :formatter="transformPurpose"></el-table-column>
                            <el-table-column header-align=center align="center" prop="emergStatus" label="是否急诊" :formatter="emerTransf"></el-table-column>
                            <el-table-column header-align=center align="center" prop="caseStatus" label="状态" :formatter="transformStatus"></el-table-column>
                            <el-table-column align=center label="操作" header-align=center width="210">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click="selectCase(scope.row)">查看详情</el-button> 
                                </template>
                            </el-table-column>
                    </el-table>
                </template>
            </div>
            <div class="page">
                <el-pagination  :page-size='rows' :page-sizes="[20,50,100]" 
                    :current-page='page' 
                    layout="total, prev, pager, next,sizes" :total="tableData.count" @current-change='currentChange' @size-change="changeSize" style="text-align:right"></el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
const OSS = require('ali-oss')
import citySelect from '@/components/city'
export default {
    name:'caseRecord',
    data(){
        return{
            userInfo:{},
            url:'https://new-zhuanzhen.oss-cn-beijing.aliyuncs.com/',
            sex:[{
                value: 'M',
                label: '男'
             },
             {
                value: 'F',
                label: '女'
             },
             {
                value: 'O',
                label: '未定义'
            }],
            tableData: {
                body: [],
                count: 0,
                page: '1'
            },
            hospAddArr:[],
            hospList:[],
            applyTime:[],//申请时间
            searchForm: {
                patientGender: '',
                patientName: '',
                regionCode:'',
                regionLevel:null,
                caseStatus:'',//病例状态
                transferPurpose:'',//转诊目的
                startApplyTime:'',//开始申请时间
                endApplyTime:"",//结束申请时间
                hospId:'',//申请医院
                page:1,
                rows:20,
            },
            page:1,
            rows:20,
            loadingInstance:'',
            //急诊
            emergStatusList:[
                {"code":"1","value":"是"},
                {"code":"0","value":"否"},
            ],
            //转诊目的
            purposeList:[
                {"code":"01","value":"门诊"},
                {"code":"02","value":"住院"},
                {"code":"03","value":"检查"},
                {"code":"04","value":"随访"},
                {"code":"05","value":"康复"},
                {"code":"99","value":"其他"},
            ],
            //状态列表
            statusList:[
                {"code":"01","value":"待申请"},
                {"code":"02","value":"待确认"},
                {"code":"03","value":"待到诊"},
                {"code":"04","value":"已到诊"},
                {"code":"05","value":"已拒绝"}
            ],
            //报销类型
            expenseList:[
                {"code":"01","value":"城镇医保"},
                {"code":"02","value":"职工医保"},
                {"code":"03","value":"新农合"},
                {"code":"04","value":"自费"},
                {"code":"99","value":"其他"}
            ],
            region: 'oss-cn-beijing', //'cn-beijing',//
            bucket: 'new-zhuanzhen', //文件夹名
            client:'',

        }
    },
    components:{
      'city-select':citySelect
    },
    mounted(){
        this.geCaseList();
        this.getHospList();
    },
    methods:{
        //查询
        search(){
            this.geCaseList();
        },
        //清空
        clear(){
            this.searchForm={
                patientGender: '',
                patientName: '',
                status:'',//病历状态
                modality:'',//影像类型
                startScanTime:'',//开始扫描时间
                endScanTime:'',//结束扫描时间
                startApplyTime:'',//开始申请时间
                endApplyTime:"",//结束申请时间
                hospId:'',//所属医院
                emergStatus:"",//是否急诊
            };
            this.applyTime='';
            this.hospAddArr=[];
            this.hospList=[];
            this.page=1;
            this.geCaseList();
        },
        getOss(){
          //获得oss临时账号
          this.$ajax.post(this.$domain.getReadAndWriteOSS,{})
            .then( res => {
              this.$common.getConsole('upload——获取oss',res)
              if (!(res.data.data)) {
                throw new Error('获取OSS参数失败')
              }
              this.client = new OSS({
                region: this.region,
                accessKeyId: res.data.data.ossAccessKeyId,
                accessKeySecret: res.data.data.ossAccessKeySecret,
                stsToken: res.data.data.ossSecurityToken,
                bucket: this.bucket
              })
            })
        },
        //删除附件
        deleteMsg(val){
          this.client.delete(val);
        },
        refresh(){
            this.clear();
        },
        //查询全部病例
        geCaseList(){
            this.searchForm.page=this.page
            this.searchForm.rows=this.rows
            console.log(this.searchForm)
            this.$ajax.post(this.$domain.caseList,this.searchForm)
            .then(ret=>{
                this.$common.getConsole('caseManage.vue——获取病例列表',ret.data);
                if(ret.data.code==200){
                    this.tableData.body=ret.data.data.list;
                    this.tableData.count=ret.data.data.count;
                    this.caseCount=ret.data.data.count;
                }
                else if(ret.data.code=='201'){
                    this.tableData.body=[];
                    this.tableData.count=0;
                }
                else if(ret.data.code=='502'){
                    this.$message.error('登录失效！请重新登录');
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message)
                }
            })
            .catch(err=>{
                console.log('%c '+err,'color:red');
            })
        },
        //查看详情
        selectCase(row){
            this.$common.setStorage('caseMsg',row);
            this.$router.push({path:'/caseDetail'})
        },
        //获得医院列表
        getHospList(code,level){
            this.$ajax.post(this.$domain.listByRegion,{
                code:code,
                level:level
            })
            .then(ret=>{
                this.$common.getConsole('followUp.vue——根据区域获得医院列表',ret.data);
                if(ret.data.code==200){
                    this.hospList=ret.data.data;
                }
                else if(ret.data.code=='502'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
            .catch(err=>{
                console.log('%c '+err,'color:red')
            })
        },
        //申请时间段选择
        applyTimeChange(val){
            this.searchForm.startApplyTime=this.$common.format(val[0],'yyyy-MM-dd')+' 00:00:00';
            this.searchForm.endApplyTime=this.$common.format(val[1],'yyyy-MM-dd')+' 23:59:59';
        },
        //分页选择
        currentChange(val){
            this.page=val
            this.geCaseList()
        },

        changeSize(val){
            this.rows=val
            this.geCaseList()
        },
        //性别转换
        sixForamt(row){
            if(row.patientGender=='F'){
                return '女';
            }
            else if(row.patientGender=='M'){
                return '男';
            }
            else{
                return '未知'
            }
        },
        //是否急诊
        emerTransf(row){
            if(row.emergStatus=='1'){
                return '是';
            }
            else{
                return '否'
            }
        },
        //状态文字转换
        transformStatus(row){
            for(var i=0;i<this.statusList.length;i++){
                if(row.caseStatus==this.statusList[i].code){
                    return this.statusList[i].value 
                }
            }
        },
        //转诊目的转换
        transformPurpose(row){
            for(var i=0;i<this.purposeList.length;i++){
                if(row.transferPurpose==this.purposeList[i].code){
                    return this.purposeList[i].value
                }
            }
        },
        //报销类型
        transformExpense(row){
            for(var i=0;i<this.expenseList.length;i++){
                if(row.expenseType==this.expenseList[i].code){
                    return this.expenseList[i].value
                }
            }
        },
        exportExcel(){
            if(this.$common.exportMax(this.tableData.count)){
                return
            }
            this.$ajax.post(this.$domain.exportCaseStatistics,this.searchForm)
            .then(ret=>{
                this.$common.getConsole('caseManage.vue——导出',ret.data)
                if(ret.data.code==200){
                    window.open(this.url + ret.data.data);
                    let _this=this;
                    setTimeout(function () {
                        _this.deleteMsg(ret.data.data)
                    },300000)
                }
                else{
                    this.$message.error("导出失败")
                }
            })
            .catch(err=>{
                console.log('%c '+err,'color:red');
            })
        }
    },
    watch:{
        hospAddArr(val){
            this.getHospList(val[val.length-1],val.length);
            this.searchForm.regionCode=val[val.length-1];
            this.searchForm.regionLevel=val.length;
        }
    }
}
</script>

<style lang="scss" scoped>
#caseManage {
    width:100%;
    // min-width:1800px;
    padding:0 4%;
    box-sizing: border-box;
    text-align: left;
}
.el-form-item__content{
    margin-left:0 !important;
    display: flex;
    justify-content: flex-start
}
.el-table .success-row {
    background: #f0f9eb;
}
.el-table .success-color {
    background: #EA6F5A;
}
.el-tabs__nav-scroll{
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/caseManage.vue